import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs';
import { Competences } from 'src/app/_enums/competences';
import { Competence } from 'src/app/_models/competence';
import { CompetencePersonnage } from 'src/app/_models/competencePersonnage';
import { Personnage } from 'src/app/_models/personnage';
import { CharacterSheetService } from 'src/app/_services/character-sheet.service';
import { CompetenceService } from 'src/app/_services/competence.service';

@Component({
  selector: 'app-character-sheet-competences',
  templateUrl: './competences.component.html',
  styleUrls: ['./competences.component.scss']
})
export class CharacterSheetCompetencesComponent implements OnInit {
  // Input decorator
  @Input()  personnage!: Personnage;
  @Output() personnageChange = new EventEmitter<Personnage>();
  competences!: Competence[];
  addCompetenceForm!: FormGroup;

  availableCompetences!: Competence[];

  test: any;
  submitted: boolean = false;

  constructor(private formBuilder: FormBuilder, private competenceService: CompetenceService, private characterSheetService: CharacterSheetService) { }

  ngOnInit() {
    this.initializeCompetenceForm();
    this.competenceService.getCompetences()          
    .pipe(first())
    .subscribe({
      next: (competences) => 
      {
        this.competences = competences;
        this.availableCompetences = this.getAvailableCompetences(this.competences);
      }
    });

  }

  initializeCompetenceForm() {
    this.addCompetenceForm = this.formBuilder.group({
      addedCompetenceId: ['', Validators.required]
    })
  };

  // convenience getter for easy access to form fields
  get f() { return this.addCompetenceForm.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.addCompetenceForm.invalid)
    {
    // Get all Form Controls keys and loop them
      Object.keys(this.addCompetenceForm.controls).forEach(key => {
      // Get errors of every form control
      var control = this.addCompetenceForm.get(key);
      if(control != null)
      {
        console.log(key);
        console.log(control.errors);
      }
    });
      return;
    }

    this.characterSheetService.addCompetence({
      personnageId: this.personnage.id,
      competenceId: this.addCompetenceForm.controls['addedCompetenceId'].value
    })
    .pipe(first())
    .subscribe({
      next: (result) => {
        this.personnage = result.result as Personnage;
        this.personnageChange.emit(this.personnage);

        this.addCompetenceForm.controls['addedCompetenceId'].setValue('');
        this.submitted = false;

        this.availableCompetences = this.getAvailableCompetences(this.competences);
      }
    });
  }


  public RemoveCompetence(competencePersonnage: CompetencePersonnage): void {
      this.characterSheetService.removeCompetence({
        personnageId: competencePersonnage.personnageId,
        competenceId: competencePersonnage.competenceId
      })
      .pipe(first())
      .subscribe({
        next: (result) => {
          this.personnage = result.result as Personnage;
          this.personnageChange.emit(this.personnage);

          this.availableCompetences = this.getAvailableCompetences(this.competences);
        }
      });
  }

  public AddNiveauCompetence(competencePersonnage: CompetencePersonnage): void {
    this.characterSheetService.addNiveauCompetence({
      personnageId: competencePersonnage.personnageId,
      competenceId: competencePersonnage.competenceId
    })
    .pipe(first())
    .subscribe({
      next: (result) => {
        this.personnage = result.result as Personnage;
        this.personnageChange.emit(this.personnage);

        this.availableCompetences = this.getAvailableCompetences(this.competences);
      }
    });
}

  public RemoveNiveauCompetence(competencePersonnage: CompetencePersonnage): void {
    this.characterSheetService.removeNiveauCompetence({
      personnageId: competencePersonnage.personnageId,
      competenceId: competencePersonnage.competenceId
    })
    .pipe(first())
    .subscribe({
      next: (result) => {
        this.personnage = result.result as Personnage;
        this.personnageChange.emit(this.personnage);

        this.availableCompetences = this.getAvailableCompetences(this.competences);
      }
    });
  }

  public GetCompetence(competenceId: number): Competence | null {
    if (this.competences)
     return this.competences.filter(c => c.id == competenceId)[0];
    else
      return null;
  }

  public getAvailableCompetences(competences: Competence[]): any[] {
    if (!competences) {
      return [];
    }

    return competences.filter(c => {
      return c.isDisponible && (this.personnage?.competences?.filter(pc => pc.competenceId == c.id).length == 0);
    });
  }

  public canAddNiveauCompetence(competencePersonnage: CompetencePersonnage): boolean {

    var competence = this.GetCompetence(competencePersonnage.competenceId);
    if (competencePersonnage.niveau == 3)
      return false;
    if (competencePersonnage.niveau == 2 && !competence?.niveau3 )
      return false;
    if (competencePersonnage.niveau == 1 && !competence?.niveau2 )
      return false;      

    return true;
  }

  public canRemoveNiveauCompetence(competencePersonnage: CompetencePersonnage): boolean {

    var competence = this.GetCompetence(competencePersonnage.competenceId);
    if (competencePersonnage.niveau == 1)
      return false;

    return true;
  }

  public canRemoveCompetence(competencePersonnage: CompetencePersonnage): boolean {

    var competence = this.GetCompetence(competencePersonnage.competenceId);
    if (competencePersonnage.niveau != 1)
      return false;
    if (!competence?.isDisponible)
      return false;
    if (competencePersonnage.competenceId == Competences.idDague)
      return false;
    return true;
  }
}